import { TaskStatus } from './task-status';

export class UserStatus extends TaskStatus
{}
